// On the grants filter, there are subfields of 'region' and 'grant amount' which need to be conditionally
// revealed depending on whether the user selects 'UK' or 'India' from the countries field
var grantDatabaseFilter = document.getElementById("grantDatabaseFilter");

if (typeof(grantDatabaseFilter) != 'undefined' && grantDatabaseFilter != null) {
  var countryRadio = grantDatabaseFilter.querySelectorAll("input[name=countries]");
  var regionUk = grantDatabaseFilter.querySelector("#fieldsetRegionUk");
  var regionIndia = grantDatabaseFilter.querySelector("#fieldsetRegionIndia");
  var grantAmountUk = grantDatabaseFilter.querySelector("#fieldsetGrantAmountGbp");
  var grantAmountIndia = grantDatabaseFilter.querySelector("#fieldsetGrantAmountInr");
  var yearCheckbox = grantDatabaseFilter.querySelectorAll("#fieldsetYear input[type=checkbox]");

  // toggle region and grant amount fieldsets by country
  for (let i = 0; i < countryRadio.length; i++) {
    if (countryRadio[i].checked) {
      toggleFieldsets(countryRadio[i]);
    }

    countryRadio[i].onchange = function() {
      toggleFieldsets(countryRadio[i]);
    }
  }

  // pre year value cannot be selected with other year values
  for (let i = 0; i < yearCheckbox.length; i++) {
    yearCheckbox[i].onchange = function() {
      if (this.value.includes("Pre") ) {
        yearCheckbox.forEach(function(input) {
          input.checked = false;
        });

        if (this.classList.contains("checked")) {
          this.checked = false;
          this.classList.remove("checked");
        } else {
          this.checked = true;
          this.classList.add("checked");
        }
      } else {
        yearCheckbox[yearCheckbox.length - 1].checked = false;
      }
    }
  }

  function toggleFieldsets(radioEl) {
    if (radioEl.id == "332") {
      regionIndia.style.display = "none";
      grantAmountIndia.style.display = "none";
      regionUk.style.display = "block";
      grantAmountUk.style.display = "block";
    }
    else if (radioEl.id == "333") {
      regionUk.style.display = "none";
      grantAmountUk.style.display = "none";
      regionIndia.style.display = "block";
      grantAmountIndia.style.display = "block";
    }
    else {
      regionUk.style.display = "none";
      grantAmountUk.style.display = "none";
      regionIndia.style.display = "none";
      grantAmountIndia.style.display = "none";
    }
  }
}
